<style>
    .comp-full-calendar {  max-width: none; }

    .full-calendar-header .header-center {
        /* border: 2px solid #e0e0e0; */
        max-width: 25em;
    }

    .full-calendar-header .header-center .title {
        font-size: 18px;
        border: 1px solid #e0e0e0;
        padding: 3px 3.1em 8px;
    }

    .prev-month, .next-month {
        margin-top: -1px;
        padding: 5px 15px 7px 15px;
        background: #2b85e4;
        font-weight: bold;
        color: #fff;
    }

    .prev-month { float: left; }
    .next-month { float: right; }
</style>

<template>
  <div>
    <Card>
        <p slot="title"> Giro Kalender </p>

        <FullCalendar :events="giroList" locale="en"
            @changeMonth="changeMonth"
            @eventClick="eventClick"
            @dayClick="dayClick"
            @moreClick="moreClick">
        </FullCalendar>
    </Card>

    <!-- Modal show detail -->
    <Modal v-model="isModalDetail">
        <p slot="header" style="color:#f60;text-align:center">
            <Icon type="information-circled"></Icon>
            <span>Detail</span>
        </p>
        <Form>
            <FormItem>
                <Row>
                    <Col span="11">
                        <FormItem v-if="isMarking" label="Marking">
                            <Input v-model="dataDetail.marking" readonly></Input>
                        </FormItem>
                        <FormItem v-else label="Marking Group">
                            <Input v-model="dataDetail.markingGroup" readonly></Input>
                        </FormItem>
                    </Col>
                    <Col span="11" offset="2">
                        <FormItem label="Tanggal Terima Giro">
                            <Input v-model="dataDetail.giroDate" readonly></Input>
                        </FormItem>
                    </Col>
                </Row>
            </FormItem>
            <FormItem>
                <Row>
                    <Col span="11">
                        <FormItem label="Tanggal Jatuh Tempo">
                            <Input v-model="dataDetail.paymentDate" readonly></Input>
                        </FormItem>
                    </Col>
                    <Col span="11" offset="2">
                        <FormItem label="Tanggal Mundur">
                            <Input v-model="dataDetail.dueDate" readonly></Input>
                        </FormItem>
                    </Col>
                </Row>
            </FormItem>
            <FormItem>
                <Row>
                    <Col span="11">
                        <FormItem label="Nomor Giro">
                            <Input v-model="dataDetail.giroNumber" readonly></Input>
                        </FormItem>
                    </Col>
                    <Col span="11" offset="2">
                        <FormItem label="Nominal Giro">
                            <Input v-model="dataDetail.giroNominal" readonly></Input>
                        </FormItem>
                    </Col>
                </Row>
            </FormItem>
            <FormItem>
                <Row>
                    <Col span="11">
                        <FormItem label="Kliring">
                            <Input v-model="dataDetail.isClearing" readonly></Input>
                        </FormItem>
                    </Col>
                    <Col span="11" offset="2">
                        <FormItem label="Dibatalkan">
                            <Input v-model="dataDetail.isCancel" readonly></Input>
                        </FormItem>
                    </Col>
                </Row>
            </FormItem>
            <FormItem label="Bank">
                <Input v-model="dataDetail.bankAccount" readonly></Input>
            </FormItem>
        </Form>
    </Modal>
  </div>
</template>

<script>
import {HTTP} from '@/components/http-lib'
import _ from 'lodash'
import moment from 'moment'
import FullCalendar from 'vue-fullcalendar'

const numeral = require('numeral');

export default {
    components: {
        FullCalendar
    },
    data () {
        return {
            isLoadingGiroList : false,
            giroList : [],
            isModalDetail: false,
            isMarking : true,
            columnsDetail: [
                {
                    title: 'Marking',
                    key: 'marking',
                },
                {
                    title: 'Tanggal Terima Giro',
                    key: 'giroDate',
                },
                {
                    title: 'Tanggal Jatuh Tempo',
                    key: 'paymentDate',
                },
                {
                    title: 'Tanggal Jatuh Tempo',
                    key: 'dueDate',
                },
                {
                    title: 'Nomor Giro',
                    key: 'giroNumber',
                },
                {
                    title: 'Nominal Giro',
                    key: 'giroNominal',
                },
                {
                    title: 'Kliring',
                    key: 'isClearing',
                },
                {
                    title: 'Bank',
                    key: 'bankAccount',
                },
            ],
            dataDetail: [],
        }
    },
    methods: {
        showDateFormatted : function(stringToFormat){
            let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
            return moment(dateToFormat).format("DD MMM YYYY")
        },
        changeMonth (start, end, current) {
            let parent = this;
            this.isLoadingGiroList = true;

            HTTP.post('giro/search', {
                isCalendar: true,
                paymentDate: current
            })
            .then(response => {
                let receivableGiro = []
                console.log({response});
                _.forEach(response.data, function(value, index) {
                    let marking = value.marking_header != null ? value.marking_header.markingheadercode : '';
                    let markingGroup = value.marking_group != null ? value.marking_group.code : ''
                    let giroNumber = value.giroNumber;
                    let giroNominal = value.giroNominal != null ? "Rp. " + numeral(value.giroNominal).format('0,0') : '';

                    let giroDate = moment(value.giroDate, 'YYYY-MM-DD hh:mm:ss').format("YYYY-MM-DD");
                    let paymentDate = (value.paymentDate != null && value.paymentDate != "0000-00-00 00:00:00") ? parent.showDateFormatted(value.paymentDate) : ''
                    let dueDate = (value.dueDate != null && value.dueDate != "0000-00-00 00:00:00") ? parent.showDateFormatted(value.dueDate) : ''
                    let bankAccount = value.bank_account != null ? value.bank_account.accountName : '-';
                    let isClearing = value.isClearing ? 'Ya' : 'Tidak';
                    let isCancel = value.isCancel ? 'Ya' : 'Tidak';

                    let detail = {
                        marking     : marking,
                        markingGroup : markingGroup,
                        giroDate    : parent.showDateFormatted(giroDate),
                        paymentDate : paymentDate,
                        dueDate     : dueDate,
                        giroNumber  : giroNumber,
                        giroNominal : giroNominal,
                        isClearing  : isClearing,
                        isCancel    : isCancel,
                        bankAccount : bankAccount,
                    }

                    let markingOrMarkingGroup = marking != '' ? marking : markingGroup;
                    let rGiro = {
                        title   : markingOrMarkingGroup + ' - ' + giroNumber,
                        start   : paymentDate,
                        end     : paymentDate,
                        detail  : detail
                    }

                    receivableGiro.push(rGiro);
                });

                this.giroList = receivableGiro;
                this.isLoadingGiroList = false;
            })
            .catch(e => {
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            });
        },
        eventClick (event, jsEvent, pos) {
            console.log({event})

            this.isModalDetail = true;
            this.isMarking = event.detail.marking != '' ? true : false;

            let detail = {
                marking     : event.detail.marking,
                markingGroup : event.detail.markingGroup,
                giroDate    : event.detail.giroDate,
                paymentDate : event.detail.paymentDate,
                dueDate     : event.detail.dueDate,
                giroNumber  : event.detail.giroNumber,
                giroNominal : event.detail.giroNominal,
                isClearing  : event.detail.isClearing,
                isCancel    : event.detail.isCancel,
                bankAccount : event.detail.bankAccount,
            };

            this.dataDetail = detail;
        },
        dayClick (day, jsEvent) {
            console.log('dayClick', day, jsEvent)
        },
        moreClick (day, events, jsEvent) {
            console.log('moreCLick', day, events, jsEvent)
        },
        getReceivableGiroList: function(){
            let parent = this;
            this.isLoadingGiroList = true;

            const current = new Date();
            const date = moment(current).format("YYYY-MM-DD")

            HTTP.post('giro/search', {
                isCalendar: true,
                paymentDate: date
            })
            .then(response => {
                let receivableGiro = []
                console.log({response});
                _.forEach(response.data, function(value, index) {
                    let marking = value.marking_header != null ? value.marking_header.markingheadercode : '';
                    let markingGroup = value.marking_group != null ? value.marking_group.code : ''
                    let giroNumber = value.giroNumber;
                    let giroNominal = value.giroNominal != null ? "Rp. " + numeral(value.giroNominal).format('0,0') : '';

                    let giroDate = moment(value.giroDate, 'YYYY-MM-DD hh:mm:ss').format("YYYY-MM-DD");
                    let paymentDate = (value.paymentDate != null && value.paymentDate != "0000-00-00 00:00:00") ? parent.showDateFormatted(value.paymentDate) : ''
                    let dueDate = (value.dueDate != null && value.dueDate != "0000-00-00 00:00:00") ? parent.showDateFormatted(value.dueDate) : ''
                    let bankAccount = value.bank_account != null ? value.bank_account.accountName : '-';
                    let isClearing = value.isClearing ? 'Ya' : 'Tidak';
                    let isCancel = value.isCancel ? 'Ya' : 'Tidak';

                    let detail = {
                        marking     : marking,
                        markingGroup : markingGroup,
                        giroDate    : parent.showDateFormatted(giroDate),
                        paymentDate : paymentDate,
                        dueDate     : dueDate,
                        giroNumber  : giroNumber,
                        giroNominal : giroNominal,
                        isClearing  : isClearing,
                        isCancel    : isCancel,
                        bankAccount : bankAccount,
                    }

                    let markingOrMarkingGroup = marking != '' ? marking : markingGroup;
                    let rGiro = {
                        title   : markingOrMarkingGroup + ' - ' + giroNumber,
                        start   : paymentDate,
                        end     : paymentDate,
                        detail  : detail
                    }

                    receivableGiro.push(rGiro);
                });

                this.giroList = receivableGiro;
                this.isLoadingGiroList = false;
            })
            .catch(e => {
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            });
        },
    },
    mounted() {
        this.getReceivableGiroList()
    }
}

</script>



// WEBPACK FOOTER //
// GiroCalendar.vue?24479e82